export type Elomrade = "SE1" | "SE2" | "SE3" | "SE4";

export const ELOMRADEN: {
  value: Elomrade;
  label: string;
  city: string;
  /** Kort beskrivning utan landsnamn – används i sökresultatet. */
  short: string;
}[] = [
  { value: "SE1", label: "SE1", city: "Luleå (norra Sverige)", short: "Luleå (norra)" },
  { value: "SE2", label: "SE2", city: "Sundsvall (norra Mellansverige)", short: "Sundsvall (norra mellan)" },
  { value: "SE3", label: "SE3", city: "Stockholm (södra Mellansverige)", short: "Stockholm (södra mellan)" },
  { value: "SE4", label: "SE4", city: "Malmö (södra Sverige)", short: "Malmö (södra)" },
];

/**
 * Uppskattar elområde utifrån svenskt postnummer.
 * Returnerar null om postnumret inte går att tolka.
 */
export function getElomradeFromPostalCode(postalCode: string): Elomrade | null {
  const digits = postalCode.replace(/\D/g, "");
  if (digits.length < 2) return null;

  const prefix = parseInt(digits.slice(0, 2), 10);
  if (Number.isNaN(prefix)) return null;

  // SE1 – norra Sverige (Norrbotten, norra Västerbotten)
  if (prefix >= 93 && prefix <= 98) return "SE1";
  // SE2 – norra Mellansverige (Sundsvall, Östersund, Gävle m.fl.)
  if ((prefix >= 80 && prefix <= 89) || (prefix >= 90 && prefix <= 92)) return "SE2";
  // SE4 – södra Sverige (Skåne, Blekinge, Halland, södra Småland)
  if ((prefix >= 20 && prefix <= 39) || prefix === 99) return prefix === 99 ? "SE1" : "SE4";
  // SE3 – södra Mellansverige (Stockholm, Göteborg, Östergötland m.fl.)
  if (prefix >= 10 && prefix <= 79) return "SE3";

  return null;
}
